// @flow
import styled, {css} from "styled-components";
import {ThankYouFloater, UnderTopBarFloater} from "../../AppStyle";
import {styles} from "../../../config";

export const UnderTopBarThankYouFloater = styled.div`
    ${ThankYouFloater};
    ${({ offerAppDownload }) => offerAppDownload ? '' : 'min-height: 30px; height: 30px;'}
    ${UnderTopBarFloater};
`;

export const ThankYouLabel = css`
    user-select: text;
    margin-bottom: 15px;
`;

export const ThankYouTitle = styled.div`
    ${ThankYouLabel};
    color: ${styles.primaryColor};
    font-weight: 500;
    font-size: 23px;
    min-width: 50%;
`;

export const ThankYouContent = styled.div`
    ${ThankYouLabel};
    margin-top: 3px;
    font-size: 15px;
    line-height: 17px;
    min-width: 50%;
    font-weight: 300;
`;



// WEBPACK FOOTER //
// ./src/Components/Screen/ThankYou/ThankYouStyle.js